import React, { CSSProperties } from "react";
import AsyncSelect from "react-select/async";
import { SingleValue, NoticeProps } from "react-select";

const InputSelectAutoSuggestNoneBorder = ({
  value,
  onChange,
  datas,
  status = false,
  isUploadJoinDate = false,
}: {
  isUploadJoinDate?: boolean;
  value: string;
  status?: boolean;
  onChange: (answer: { value: string; label: string; symbol?: string }) => void;
  datas: Array<{ value: string; label: string; symbol?: string }>;
}) => {
  const theme = localStorage.getItem("theme");
  const LoadingMessage = (props: NoticeProps<false>) => {
    return (
      <div {...props.innerProps} style={props.getStyles("loadingMessage", props) as CSSProperties}>
        {props.children}
      </div>
    );
  };

  const filterColors = (inputValue: string) => datas.filter((i) => i.label.toLowerCase().includes(inputValue.toLowerCase()));

  const promiseOptions = (inputValue: string) =>
    new Promise<Array<{ value: string; label: string; symbol?: string }>>((resolve) => {
      resolve(filterColors(inputValue));
    });

  const handleChange = (newValue: SingleValue<{ value: string; label: string; symbol?: string }>) => {
    if (newValue) {
      // Pass non-null value to the parent onChange handler
      onChange(newValue);
    }
  };

  return (
    <AsyncSelect
      placeholder={value === "" ? "Select..." : <p className=" text-gray-400 text-start p-0">{value}</p>}
      onChange={handleChange} // Updated handler
      cacheOptions
      defaultOptions
      classNamePrefix="input-select-auto-suggest"
      options={datas}
      defaultValue={datas.find((item) => item.value === value) || null}
      loadOptions={promiseOptions}
      styles={{
        // control: (baseStyles, state) => ({
        //   ...baseStyles,
        //   color: "#ffffff",
        //   borderRadius: "calc(0.75rem - 2px)",
        //   border: theme === "dark" ? "1px solid #1e293b" : "1px solid #e2e8f0",
        //   backgroundColor: theme === "dark" ? "#020817" : "#ffffff",
        // }),

        control: (baseStyles, state) => ({
          ...baseStyles,
          color: "#ffffff",
          borderRadius: 0, // remove rounded corners if not needed
          borderTop: "none",
          borderLeft: "none",
          borderRight: "none",
          borderBottom: theme === "dark" ? "1px solid #1e293b" : status ? "1px solid red" : " 1px solid #e2e8f0",
          // e2e8f0
          backgroundColor: theme === "dark" ? "#020817" : "#ffffff",
          boxShadow: "none", // prevent default react-select shadow
          padding: 0,
          // zIndex: 100,
        }),

        placeholder: (base) => ({
          ...base,
          color: theme === "dark" ? "#ffffff" : "#000000", // Set white color in dark mode
        }),
        singleValue: (base) => ({
          ...base,
          color: theme === "dark" ? "#ffffff" : "#000000", // Ensures selected value is visible
        }),
        input: (base) => ({
          ...base,
          color: theme === "dark" ? "white" : "#000000",
          height: "30px",
          padding: " 0 0 0 0",
          // Set text color for the input (non-focused state)
        }),
        menu: (base) => ({
          ...base,
          backgroundColor: `${theme === "dark" ? "#020817" : "#ffffff"}`,
          border: theme === "dark" ? "1px solid #1e293b" : "1px solid #e2e8f0",
          borderRadius: "calc(0.75rem - 2px)",
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected
            ? theme === "dark"
              ? "#2d3748"
              : "#eeeeee"
            : state.isFocused
            ? theme === "dark"
              ? "#2d3748"
              : "#eeeeee"
            : theme === "dark"
            ? "#020817"
            : "#ffffff",
          color: theme === "dark" ? "#fff" : "#000",
          cursor: "pointer",
        }),
      }}
    />
  );
};

export default InputSelectAutoSuggestNoneBorder;
